import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import { useTranslations } from 'next-intl'
import React from 'react'
import { CashbackScheduleModal } from './cashbackScheduleModal'

interface CashbackScheduleModalWrapperProps {
    open: boolean
    onClose: () => void
    cashbackSchedule: {
        message: string
        currency: string
        breakup: Array<{
            date: string
            message?: string
            amount: number
        }>
    }
}

const CashbackScheduleModalWrapper: React.FC<CashbackScheduleModalWrapperProps> = ({
    open,
    onClose,
    cashbackSchedule
}) => {
    const { formatCurrency } = useFormatCurrencyForItinerary()
    const t = useTranslations('couponTray')
    return (
        <CashbackScheduleModal
            open={open}
            onClose={onClose}
            message={cashbackSchedule.message}
            currency={cashbackSchedule.currency}
            breakup={cashbackSchedule.breakup}
            formatCurrency={formatCurrency}
            t={t}
        />
    )
}

export { CashbackScheduleModalWrapper }
export default CashbackScheduleModalWrapper
